import ko from 'knockout';
import BusinessModel from './businessModel';

function UserModel(serverUserModel) {

  var self = this;

  // Observables
  self.givenName = ko.observable(serverUserModel.givenName);
  self.familyName = ko.observable(serverUserModel.familyName);
  self.displayName = ko.observable(serverUserModel.displayName);
  self.phoneNumber = ko.observable(serverUserModel.phoneNumber);
  self.emailAddress = ko.observable(serverUserModel.emailAddress);

  self.personaId = serverUserModel.personaId;
  self.userId = serverUserModel.userId;
  self.languageCode = serverUserModel.languageCode;
  self.isBusinessAdminUser = serverUserModel.isBusinessAdminUser;

  /**
   * The registration Id for a user. Only set when a user is pre-registered and approved to register.
   * @type {string}
   */
  self.registrationId = serverUserModel.registrationId;
  self.isFullyRegistered = serverUserModel.isFullyRegistered;
  self.canCompleteRegistration = serverUserModel.canCompleteRegistration;

  self.business = new BusinessModel(serverUserModel.business);
}

export default UserModel;
